/**
 * Created by Teo on 28/03/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hospitalizationsAggregatedPerSector', {
                parent: 'hospitalizationsAggregated',
                url: '/perSector',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK', 'ROLE_REC_ADMINISTRATOR'],
                    pageTitle: 'Hospitalizations Aggregated Per Sector'
                },
                templateUrl: 'app/displays/adminIndex/hospitalizationsAggregated/perSector/hospitalizationsAggregatedPerSector.html',
                controller: 'HospitalizationsAggregatedPerSectorController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
